import { cn } from "@/lib/utils";
import { memo } from "react";

interface ActiveFiltersBarDividerProps {
  dividerClass: string;
}

const ActiveFiltersBarDividerComp = ({
  dividerClass,
}: ActiveFiltersBarDividerProps) => {
  return (
    <span
      className={cn("h-[1.375rem] w-px shrink-0 self-center", dividerClass)}
    />
  );
};

export const ActiveFiltersBarDivider = memo(ActiveFiltersBarDividerComp);
